import React from "react";

import { NavLink } from "react-router-dom";

import { IcBackGray, IcListCar, IcCalendar, IcGPS, IcWallet, IcCarRegister, IcContract } from "../../common/svg";

import * as ROUTES from "../../../constant/routes";

const url = [
	{ path: ROUTES.MY_CARS, ic: <IcListCar />, name: "Danh sách xe" },
	{ path: ROUTES.CALENDARS, ic: <IcCalendar />, name: "Lịch chung" },
	{ path: ROUTES.GPS, ic: <IcGPS />, name: "GPS có dây" },
	{ path: ROUTES.GPS_SLEEP, ic: <IcGPS />, name: "GPS không dây" },
	{ path: ROUTES.CONTRACT, ic: <IcContract />, name: "Hợp đồng mẫu" },
	{ path: ROUTES.MY_WALLET, ic: <IcWallet />, name: "Ví của tôi" },
	{ path: ROUTES.MODE_REGISTER, ic: <IcCarRegister />, name: "Đăng ký xe" },
];

export default class OwnerSidebar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isDropdown: false,
			currentUrl: ROUTES.MY_CARS,
		};

		this.wrapperRef = React.createRef();
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		document.addEventListener("click", this.handleClickOutside);
		this.setState({
			currentUrl: window.location.pathname,
		});
	}

	UNSAFE_componentWillUnmount() {
		document.removeEventListener("click", this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		const { target } = event;
		if (!this.wrapperRef.current?.contains(target)) {
			this.hideDropdown();
		}
	};

	toggleDropdown = () => {
		this.setState({
			isDropdown: !this.state.isDropdown,
		});
	};

	hideDropdown = () => {
		this.setState({
			isDropdown: false,
		});
	};

	toggleMenu = () => {
		this.props.toggleMenu();
	};

	render() {
		const { isDropdown, currentUrl } = this.state;

		return (
			<div className="sidebar-mycars">
				<div className="title">
					<h4>Xe của tôi</h4>
					<div className="wrap-svg arrow-left" onClick={this.toggleMenu}>
						<IcBackGray />
					</div>
				</div>
				<div className="sidebar">
					{url.map((item, i) => (
						<NavLink key={i.toString()} to={item.path} className="sidebar-item" activeClassName="active">
							<div className="wrap-svg">{item.ic}</div>
							<p>{item.name}</p>
						</NavLink>
					))}
				</div>
				<div className="dropdown-sidebar custom-dropdown" ref={this.wrapperRef}>
					<div className="dropdown-selected" onClick={this.toggleDropdown}>
						{url.map((item, i) => {
							if (item.path === currentUrl) {
								return (
									<React.Fragment key={i.toString()}>
										<div className="wrap-svg">{item.ic}</div>
										<p>{item.name}</p>
									</React.Fragment>
								);
							}
						})}
					</div>
					{isDropdown && (
						<div className="dropdown-option">
							{url.map((item, i) => (
								<NavLink
									to={item.path}
									onClick={() => this.hideDropdown()}
									className="dropdown-option__item"
									key={i.toString()}>
									<div className="wrap-svg">{item.ic}</div>
									<p className="text">{item.name}</p>
								</NavLink>
							))}
						</div>
					)}
				</div>
			</div>
		);
	}
}
